import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, SAMPLE_TO_SALE_SCREEN, COMMON, API_CONSTANTS } from '../../global/Constants';
import { ActivityStatusType } from '../../global/Enum';
import './sample-to-sale.css';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import ActivityHeader from '../common/ActivityHeader';
import Select from 'react-select';
import AddNewImages from '../common/AddNewImages';
import Utilities from '../../global/Utilities';
import DataProvider from '../../providers/DataProvider';
import SyncLoader from '../common/loader/SyncLoader';


class EditPlotVisitPage extends Component {
    constructor(props) {
        super(props);
        this.latitude = null;
        this.longitude = null;
        this.state = {
            activity: {},
            stage: '',
            cropHealth: '',
            remarks: '',
            images: [],
            deletedImages: [],

            stages: [
                { value: 1, label: "30" },
                { value: 2, label: "45" },
                { value: 3, label: "60" },
                { value: 4, label: "90" },
                { value: 5, label: "120 DAT" },
            ],

            cropHealths: [
                { value: 1, label: "Good" },
                { value: 2, label: "Average" },
                { value: 3, label: "Poor" },
            ]
        }
    }

    async componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.activity;
                if (activity !== undefined && activity !== null) {
                    //this.getCropDaysByCropId(activity.crop_id);
                    //let data = activity?.stage;
                    //const cropHealths = data?.params?.is_crop_health?.map(({ plot_visit_crop_health_id: value, name: label, ...rest }) => ({ value, label, ...rest }));

                    this.setState({
                        activity: activity,
                        // cropHealths: cropHealths
                    }, () => {
                        this.getParams();
                        this.getStages();

                        if (activity?.plotVisit != null) {
                            let plotVisit = activity?.plotVisit;

                            this.setState({
                                stage: plotVisit.stage,
                                cropHealth: plotVisit.cropHealth,
                                remarks: plotVisit.remark,
                                images: plotVisit.images,
                                deletedImages: plotVisit?.deletedImages,
                            });
                        } else {
                            this.setData();
                        }
                    });
                }
                this.getUserLocation();

            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }

    }

    getUserLocation = async () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const coords = position.coords;
                this.latitude = coords.latitude.toFixed(6);
                this.longitude = coords.longitude.toFixed(6);

            }, (error) => {
                Utilities.LogPrint("Error Code = " + error.code + " - " + error.message);
            });
        }
    }

    setData = () => {
        const { activity } = this.state;
        if (activity !== null && activity.activity_status_id !== ActivityStatusType.TO_START) {
            const plotVisit = activity?.data?.history?.stage_three;
            if (plotVisit !== undefined && plotVisit !== null && plotVisit.length > 0) {
                const stageThree = plotVisit[plotVisit.length - 1];

                let stage = {};
                const plotVisitStages = DataProvider.getInstance().getPlotVisitStages();
                if (plotVisitStages) {
                    const stageItem = plotVisitStages.find(item => item.crop_days_id === stageThree.crop_days_id);
                    Utilities.LogPrint("stageItem:-", stageItem);
                    stage = {
                        value: stageItem.crop_days_id,
                        label: stageItem.crop_day
                    }
                }

                let cropHealth = {
                    value: stageThree.crop_plot_visit_crop_health_id,
                    label: stageThree.crop_plot_visit_crop_health_title
                }

                this.setState({
                    stage: stage,
                    cropHealth: cropHealth,
                    remarks: stageThree.remark,
                    images: stageThree.images
                });
            }
        }
    }

    getParams = () => {
        const { activity } = this.state;

        // For Crop Health
        const cropHealths = DataProvider.getInstance().getCropHealths();
        Utilities.LogPrint("CropHealths:-", cropHealths);
        if (cropHealths.length > 0) {
            const cropHealthsArray = cropHealths.filter(item => {
                return (item.crop_id === activity.crop_id && item.is_active === 1);
            });
            Utilities.LogPrint("CropHealths:-", cropHealthsArray);

            this.setState({
                cropHealths: cropHealthsArray?.map(({ plot_visit_crop_health_id: value, plot_visit_crop_health_crop_name: label, ...rest }) => ({ value, label, ...rest }))
            });
        }

        // For Stage
        // const plotVisitStages = DataProvider.getInstance().getPlotVisitStages();
        // Utilities.LogPrint("PlotVisitStages:-", plotVisitStages);
        // if (plotVisitStages.length > 0) {
        //     let stages = [];
        //     for (let index = 0; index < plotVisitStages?.length; index++) {
        //         const item = plotVisitStages[index];
        //         if (item.crop_id === activity.crop_id && item.is_active === 1 && item?.is_plot_visit_day === 1) {
        //             let stage = {
        //                 value: item.crop_days_id,
        //                 label: item.crop_day
        //             }
        //             stages.push(stage);
        //         }
        //     }
        //     this.setState({
        //         stages: stages,
        //         stage: this.getDayById(activity?.stage?.params?.plot_visit_stage_id),
        //     });
        // }
    }

    getStages = () => {

        const { activity } = this.state;
        const plotVisitStages = DataProvider.getInstance().getPlotVisitStages();
        const plotVisit = activity?.data?.history?.stage_three;
        if (plotVisit !== undefined && plotVisit !== null && plotVisit.length > 0) {
            const stageThree = plotVisit[plotVisit.length - 1];
            Utilities.LogPrint("StageThree", stageThree);

            if (plotVisitStages.length > 0) {
                let stages = [];
                for (let index = 0; index < plotVisitStages?.length; index++) {
                    const item = plotVisitStages[index];
                    if (item.crop_id === activity.crop_id &&
                        item.is_active === 1 &&
                        item?.is_plot_visit_day === 1 &&
                        item.crop_days_id !== stageThree?.crop_days_id) {

                        let stage = {
                            value: item.crop_days_id,
                            label: item.crop_day
                        }
                        stages.push(stage);
                    }
                }
                Utilities.LogPrint("PlotVisitStages Final:-", stages);
                this.setState({
                    stages: stages,
                    stage: this.getDayById(activity?.stage?.params?.plot_visit_stage_id),
                });
            }

        } else {
            Utilities.LogPrint("PlotVisitStages:-", plotVisitStages);
            if (plotVisitStages.length > 0) {
                let stages = [];
                for (let index = 0; index < plotVisitStages?.length; index++) {
                    const item = plotVisitStages[index];
                    if (item.crop_id === activity.crop_id && item.is_active === 1 && item?.is_plot_visit_day === 1) {
                        let stage = {
                            value: item.crop_days_id,
                            label: item.crop_day
                        }
                        stages.push(stage);
                    }
                }
                this.setState({
                    stages: stages,
                    stage: this.getDayById(activity?.stage?.params?.plot_visit_stage_id),
                });
            }
        }
    }

    getDayById = (dayId) => {
        const plotVisitStages = DataProvider.getInstance().getPlotVisitStages();
        if (plotVisitStages) {
            const stage = plotVisitStages.find(item => item.days_id === dayId);
            Utilities.LogPrint(`stage:`, stage);
            let stageObj = {
                value: stage?.crop_days_id,
                label: stage?.crop_day
            }
            return stageObj;
        }
        return "";
    }


    handleBackButton = () => {
        this.props.history.goBack();
        //this.props.history.push(ALL_ROUTES.SAMPLE_TO_SALE_ROUTE);
        // this.props.history.push({
        //     pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
        //     state: { activity: this.state.activity }
        // });
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleStageChange = item => {
        this.setState({ stage: item });
    };

    handleCropHealthChange = item => {
        this.setState({ cropHealth: item });
    };

    handleAddImages = (images) => {
        Utilities.LogPrint("Images", images);
        this.setState({ images: images });
    }

    handleDeleteImages = (deletedImage) => {
        var deletedImagesArray = this.state.deletedImages.slice();
        deletedImagesArray.push({ image_id: deletedImage.image_id });
        if (deletedImagesArray.length > 0) {
            Utilities.LogPrint("DeletedImages", deletedImagesArray);
            this.setState({ deletedImages: deletedImagesArray });
        }
    }


    handleSaveButton = () => {
        const { stage, cropHealth, remarks, images, deletedImages } = this.state;

        let plotVisit = {
            stage: stage,
            cropHealth: cropHealth,
            remark: remarks,
            images: images,
            deletedImages: deletedImages,
            latitude: this.latitude,
            longitude: this.longitude
        }

        this.setState(prevState => ({
            activity: { ...prevState.activity, plotVisit: plotVisit }
        }), () => {
            Utilities.LogPrint("plotVisit", this.state.activity);

            if (this.state.activity?.isEdit) {
                this.props.history.replace({
                    pathname: ALL_ROUTES.EDIT_SAMPLE_TO_SALE,
                    state: { activity: this.state.activity }
                });
            } else {
                this.props.history.replace({
                    pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
                    state: { activity: this.state.activity }
                });
            }

            // this.props.history.push({
            //     pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
            //     state: { activity: this.state.activity }
            // });
        });


        // let plotVisitObj = {
        //     date: Utilities.getCurrentDate(),
        //     crop_calendar_plot_visit_id: data?.params?.crop_calendar_plot_visit_id,
        //     crop_plot_visit_crop_health_id: cropHealth.value,
        //     crop_days_id: stage.value
        // }

        // const formData = new FormData();
        // formData.append("activity_id", activity.activity_id);
        // formData.append("stage_id", data?.stage_id);
        // formData.append("activity_plot_visits", JSON.stringify(plotVisitObj));

        // try {
        //     ApiServices.storeSampleToSaleById(formData)
        //         .then(response => {
        //             Utilities.LogPrint("API_DATA: ---->", response);
        //             this.setState({ isLoading: false });
        //             if (response.success) {
        //                 //const data = response.data;
        //                 this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
        //                 // if (data != null) {

        //                 // }
        //             } else {
        //                 Utilities.LogPrint("Status", response.message);
        //                 if (response.message !== undefined && response.message) {
        //                     this.setState({
        //                         errorMsg: response.message
        //                     });
        //                 }
        //             }
        //         }).catch(error => {
        //             this.setState({ isLoading: false, errorMsg: error });
        //         });
        // } catch (error) {
        //     this.setState({ isLoading: false, errorMsg: error });
        // }
    }


    isFormValid() {
        const { stage, cropHealth, images } = this.state;
        return !stage || !cropHealth || images?.length === 0 || images === undefined;
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { activity, remarks, stages, cropHealths, cropHealth, stage, images } = this.state;
        const { isSyncLoading, tableName } = this.state;
        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-xl-6 col-lg-7 col-md-9 col-12">
                            <ActivityHeader
                                type={4}
                                code={activity?.activity_tag}
                                title={SAMPLE_TO_SALE_SCREEN.PLOT_VISIT}
                                subTitle={activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name} />

                        </div>
                        <div className="col-xl-6 col-lg-5 col-md-3 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary min-w-182 krishak-cancel-btn" onClick={this.handleBackButton}>Back</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <form>
                                <div className="harvest-details">
                                    <div className="row">
                                        <div className="col-12 col-lg-5 col-md-6">
                                            <div className="form-group">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.STAGE} (DAS)</label>
                                                <Select className="max-w-360"
                                                    value={stage}
                                                    onChange={this.handleStageChange}
                                                    options={stages}
                                                    placeholder="Select the stage"
                                                    isClearable={false} />

                                                {/* <select className="form-control max-w-360">
                                                    <option value="">Select the Stage</option>
                                                    <option value="">30</option>
                                                    <option value="">45</option>
                                                </select> */}
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-5 col-md-6">
                                            <div className="form-group">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.CROP_HEALTH}</label>
                                                <Select className=" max-w-360"
                                                    value={cropHealth}
                                                    onChange={this.handleCropHealthChange}
                                                    options={cropHealths}
                                                    placeholder="Select the health"
                                                    isClearable={false} />
                                                {/* <select className="form-control max-w-360">
                                                    <option value="">Select the Health</option>
                                                    <option value="">Good</option>
                                                    <option value="">Average</option>
                                                    <option value="">Poor</option>
                                                </select> */}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="font-weight-medium mt-2">{COMMON.REMARKS} <span className="font-weight-normal">(if any)</span></label>
                                                <textarea className="form-control" rows="4" name="remarks" value={remarks} onChange={this.changeHandler}></textarea>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <AddNewImages
                                                handleAddImages={this.handleAddImages}
                                                images={images}
                                                handleDeleteImages={this.handleDeleteImages} />
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 d-flex button-grp-bottom">
                            <button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn d-md-none" onClick={this.handleBackButton}>{COMMON.BACK}</button>
                            <button className="btn btn-primary w-50 mt-md-4" onClick={this.handleSaveButton} disabled={this.isFormValid()}>{COMMON.SAVE}</button>
                        </div>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
            </div>
        )
    }
}

export default withRouter(EditPlotVisitPage)